
<!--
 * @Description: 学生 详情 请假信息
 * @Author: PF
 * @Date: 2023-11-30 10:20:27
 * @LastEditors: PF
 * @LastEditTime: 2025-12-16 08:50:18
-->
<template>
  <div class="hp100" v-if="tableData.length">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="请假天数" align="center" >
        <template #default="scope">
          <span>{{scope.row.qjts}}天</span>
        </template>
      </el-table-column>
      <el-table-column label="请假时间" align="center" width="300">
        <template #default="scope">
          <span v-if="scope.row.qjkssj !==null && scope.row.qjjssj !==null">
            {{ scope.row.qjkssj }}至{{ scope.row.qjjssj }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="请假类型" prop="qjlxmc" align="center" />
      <el-table-column label="请假原因" prop="qjyy" align="center" />
      <el-table-column label="状态" fixed="right" align="center">
        <template #default="scope">
          <!-- 0-已录入，1-已提交，9-审批通过，10-拒绝，20-生效，21-已销假 -->
          <span v-if="scope.row.zt">{{scope.row.zt.name}}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="80">
        <template #default="scope">
          <el-button link type="success" @click="openDetail=true; tcrow=scope.row">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-empty v-else class="hp100" description="暂无信息" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="tcrow" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import detail from '@/pages/xuesheng/banjishiwuguanli/xueshengqingjia/detail.vue'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])
watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/jiaowu/xueshengqingjiajilu/list', data: tableData, parms: { xsid: props.row.id, order: 'qjkssj', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
const tcrow = ref({})
const openDetail = ref(false)
</script>
